import { create } from "zustand";
import { persist } from "zustand/middleware";

const normalizeStaff = (payload) => {
    if (Array.isArray(payload)) {
        return payload;
    }

    if (payload && Array.isArray(payload.staff)) {
        return payload.staff;
    }

    if (payload && Array.isArray(payload.products)) {
        return payload.products;
    }

    return [];
};

const useStaffStore = create(
    persist(
        (set) => ({
            staff: [],
            setStaff: (staff) => set({ staff: normalizeStaff(staff) }),
        }),
        {
            name: "staff-storage",
        }
    )
);

export default useStaffStore;